import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "store";
import { useWindowDimensions } from "resources/BrowserManager";
import axios from "axios";
import strings from "resources/strings";
import { Flex, Alert, Typography, Button, Modal, Input, message } from "antd";
const { Text } = Typography;
import { CheckOutlined } from "@ant-design/icons";

import "./style.scss";

function ModalAccountDelete({ openTitle, description }) {
  const { isSmallView } = useWindowDimensions();

  const navigate = useNavigate();

  const token = useStore((state) => state.token);
  const clearStore = useStore((state) => state.clearStore);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHandlingRequest, setIsHandlingRequest] = useState(false);
  const [isOTPReady, setIsOTPReady] = useState(false);
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [isHandlingOTPSent, setIsHandlingOTPSent] = useState(false);
  const [OTPValue, setOTPValue] = useState(null);

  const inputOTPRef = useRef(null);

  useEffect(() => {
    if (inputOTPRef) {
      inputOTPRef?.current?.focus();
    }
  }, [isOTPSent]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsHandlingRequest(false);
    setIsHandlingOTPSent(false);
    setIsOTPReady(false);
    setIsOTPSent(false);
    setOTPValue(null);
    setIsModalOpen(false);
  };

  const handleDelete = async () => {
    setIsHandlingRequest(true);

    //Call server
    const res = await postUserDelete(OTPValue);

    if (res !== 1) {
      setIsHandlingRequest(false);

      if (res === 3000) {
        message.error(strings.alertInvalidAccountDeleteOTP);
      } else {
        message.error(strings.alertUnexpectedError);
      }

      return;
    }

    //Clear local variables and refresh
    clearStore();
    navigate("/login");
    message.success(strings.alertAccountDeletionOk, 10);
  };

  const handleOTPSent = async () => {
    setIsHandlingOTPSent(true);
    await getUserEmailTokenAccountDelete(token);
    //Update state after server call
    setIsOTPSent(true);
    setIsHandlingOTPSent(false);
  };

  const postUserDelete = async (OTPValue) => {
    let path = "/user/delete";
    let headers = { token: token };
    let payload = {
      data: {
        email_token: OTPValue,
      },
    };
    const response = await axios
      .post(path, payload, { headers })
      .catch((error) => {
        return -1;
      });

    if (response.data?.response?.code === 2000) {
      return 1;
    }

    return response.data?.response?.code;
  };

  const getUserEmailTokenAccountDelete = async (token) => {
    const requestHeaders = { token };
    let requestData = {
      type: "delete",
    };

    const requestPath = "/user/email-token";
    const responseApi = await axios
      .get(requestPath, { headers: requestHeaders, params: requestData })
      .catch((error) => {
        console.log(error);
      });

    if (!responseApi) {
      return -1;
    }

    const responseCode = responseApi.data.response.code;

    if (responseCode !== 2000) {
      return -1;
    }

    return 1;
  };

  const onOTPInput = (value) => {
    if (!value.target.value) {
      setIsOTPReady(false);
    }
  };

  const onOTPChange = (text) => {
    setIsOTPReady(true);
    setOTPValue(text);
  };

  return (
    <>
      <Button
        danger
        type="primary"
        onClick={showModal}
        style={{ minWidth: "150px" }}
      >
        {openTitle}...
      </Button>

      <Modal
        title={openTitle}
        open={isModalOpen}
        onCancel={handleCancel}
        width={860}
        destroyOnClose={true}
        footer={null}
        maskClosable={!isHandlingRequest}
        closable={!isHandlingRequest}
      >
        <Flex vertical gap={20}>
          <Text>{description}</Text>

          <Alert
            message="¡Esta acción es permanente e irreversible! Para confirmar la
            eliminación de tu cuenta, deberás verificar la acción con un código
            de seguridad enviado a tu correo electrónico."
            type="warning"
            showIcon
          />

          <Flex gap={20} style={{ marginTop: "20px" }} vertical={isSmallView}>
            <Button
              type="primary"
              disabled={isOTPSent}
              loading={isHandlingOTPSent}
              onClick={handleOTPSent}
              icon={isOTPSent ? <CheckOutlined /> : null}
            >
              Obtener código
            </Button>
            <Flex justify="center">
              <Input.OTP
                formatter={(str) => str.toUpperCase()}
                onInput={onOTPInput}
                onChange={onOTPChange}
                disabled={!isOTPSent || isHandlingRequest}
                ref={inputOTPRef}
                style={{
                  width: "210px",
                  textAlign: "center",
                }}
              />
            </Flex>

            <Button
              type="primary"
              danger
              loading={isHandlingRequest}
              disabled={!!!isOTPReady}
              onClick={handleDelete}
            >
              {openTitle}
            </Button>
          </Flex>

          <Flex justify="flex-end">
            <Button
              type="primary"
              disabled={isHandlingRequest}
              onClick={handleCancel}
            >
              Cancelar
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
}

export default ModalAccountDelete;
